export const after10thOptions = [
  {
    id: 'science-stream',
    title: 'Science Stream (PCM/PCB)',
    icon: '🔬',
    duration: '2 years (11th & 12th)',
    description: 'Gateway to Engineering, Medical, Research & Technology careers.',
    subjects: ['Physics', 'Chemistry', 'Mathematics (PCM)', 'Biology (PCB)', 'Computer Science'],
    careerPaths: ['Engineering', 'Medical/MBBS', 'Research', 'Pharmacy', 'Architecture'],
    tag: 'Most Popular',
    gradient: 'from-violet-500 to-indigo-600',
    highlight: true,
  },
  {
    id: 'commerce-stream',
    title: 'Commerce Stream',
    icon: '📊',
    duration: '2 years (11th & 12th)',
    description: 'Opens doors to Finance, Banking, Business & Management careers.',
    subjects: ['Accountancy', 'Business Studies', 'Economics', 'Mathematics', 'English'],
    careerPaths: ['CA/CMA/CS', 'BBA/MBA', 'Banking', 'Entrepreneurship', 'Law'],
    tag: 'High Demand',
    gradient: 'from-blue-500 to-cyan-500',
    highlight: false,
  },
  {
    id: 'arts-stream',
    title: 'Arts / Humanities Stream',
    icon: '🎨',
    duration: '2 years (11th & 12th)',
    description: 'Leads to Law, Design, Journalism, Teaching & Creative careers.',
    subjects: ['History', 'Geography', 'Political Science', 'Psychology', 'Sociology'],
    careerPaths: ['Law', 'Journalism', 'Civil Services (IAS/IPS)', 'Teaching', 'Design'],
    tag: 'Creative & Diverse',
    gradient: 'from-pink-500 to-rose-500',
    highlight: false,
  },
  {
    id: 'iti',
    title: 'ITI (Industrial Training)',
    icon: '🔧',
    duration: '6 months – 2 years',
    description: 'Skill-based vocational training for quick employment in technical trades.',
    subjects: ['Electrician', 'Fitter', 'Welder', 'Mechanic', 'Plumber', 'Turner'],
    careerPaths: ['Govt Jobs', 'Private Industry', 'Self Employment', 'Apprenticeships'],
    tag: 'Job Ready',
    gradient: 'from-orange-500 to-amber-500',
    highlight: false,
  },
  {
    id: 'polytechnic',
    title: 'Polytechnic / Diploma',
    icon: '⚙️',
    duration: '3 years',
    description: 'Technical diploma in engineering trades. Direct entry to B.Tech 2nd year.',
    subjects: ['Civil', 'Mechanical', 'Electrical', 'Computer', 'Electronics'],
    careerPaths: ['Junior Engineer', 'B.Tech Lateral Entry', 'Govt Diploma Jobs', 'Private Sector'],
    tag: 'Lateral Entry',
    gradient: 'from-teal-500 to-green-500',
    highlight: false,
  },
  {
    id: 'nios',
    title: 'NIOS / Open School',
    icon: '📚',
    duration: 'Flexible',
    description: 'Flexible learning with work or other activities. Valid for all competitive exams.',
    subjects: ['All streams available', 'Self-paced learning', 'Cost effective'],
    careerPaths: ['All career options after 12th', 'Competitive Exams', 'Further Studies'],
    tag: 'Flexible',
    gradient: 'from-slate-500 to-gray-600',
    highlight: false,
  },
];

export const engineeringCareers = {
  id: 'engineering',
  title: 'Engineering & Technology',
  icon: '⚙️',
  gradient: 'from-violet-600 to-indigo-700',
  bgLight: 'bg-violet-50',
  textColor: 'text-violet-700',
  borderColor: 'border-violet-200',
  eligibility: 'After 12th (PCM) | Min 50-75% marks',
  overview: 'Engineering is one of India\'s most sought-after career paths with millions of opportunities in software, AI/ML, DevOps, electronics, circuit design, manufacturing, construction, aerospace, and more.',
  studentMustKnow: [
    'Choose a branch based on your interest, not only the package',
    'Strong Maths and Physics basics help in almost every engineering branch',
    'Good colleges matter because labs, projects, and placements shape growth',
    'Internships, GitHub projects, and certifications boost your profile early',
  ],
  programmingLanguages: ['Python', 'C++', 'Java', 'JavaScript', 'SQL'],
  branches: [
    {
      name: 'Computer Science, Software & DevOps',
      icon: '💻',
      jobs: ['Software Engineer', 'DevOps Engineer', 'Cloud Engineer', 'Backend Engineer', 'Cybersecurity Analyst'],
      avgSalary: '₹4L – ₹50L/year',
      demand: 'Very High',
    },
    {
      name: 'AI, ML & Data Science',
      icon: '🤖',
      jobs: ['AI Engineer', 'ML Engineer', 'Data Scientist', 'Prompt Engineer', 'Applied Scientist'],
      avgSalary: '₹6L – ₹60L/year',
      demand: 'Extremely High',
    },
    {
      name: 'Electronics, Circuit & Embedded',
      icon: '🔌',
      jobs: ['Circuit Design Engineer', 'Embedded Engineer', 'VLSI Engineer', 'PCB Designer', 'Hardware Engineer'],
      avgSalary: '₹4L – ₹30L/year',
      demand: 'High',
    },
    {
      name: 'Electrical & Power Systems',
      icon: '⚡',
      jobs: ['Electrical Engineer', 'Power Systems Engineer', 'Automation Engineer', 'Control Systems Engineer'],
      avgSalary: '₹3.5L – ₹22L/year',
      demand: 'High',
    },
    {
      name: 'Mechanical Engineering',
      icon: '🔩',
      jobs: ['Design Engineer', 'Production Manager', 'Automobile Engineer', 'Robotics Engineer'],
      avgSalary: '₹3.5L – ₹25L/year',
      demand: 'High',
    },
    {
      name: 'Civil Engineering',
      icon: '🏗️',
      jobs: ['Site Engineer', 'Structural Engineer', 'Urban Planner', 'Project Manager'],
      avgSalary: '₹3L – ₹20L/year',
      demand: 'High',
    },
    {
      name: 'Chemical Engineering',
      icon: '🧪',
      jobs: ['Process Engineer', 'R&D Scientist', 'Petrochemical Engineer', 'Environmental Engineer'],
      avgSalary: '₹3L – ₹18L/year',
      demand: 'Moderate',
    },
    {
      name: 'Aerospace Engineering',
      icon: '✈️',
      jobs: ['Aerospace Engineer', 'Avionics Engineer', 'Aircraft Designer', 'ISRO/DRDO Scientist'],
      avgSalary: '₹5L – ₹30L/year',
      demand: 'Moderate',
    },
    {
      name: 'Biotechnology Engineering',
      icon: '🧬',
      jobs: ['Biotech Researcher', 'Genetic Engineer', 'Pharmaceutical R&D', 'Bioinformatician'],
      avgSalary: '₹3L – ₹20L/year',
      demand: 'Growing',
    },
  ],
  entranceExams: [
    { name: 'JEE Main', description: 'National level exam for NITs, IIITs & CFTIs', month: 'Jan/Apr' },
    { name: 'JEE Advanced', description: 'For admission to 23 IITs (Top 2.5L JEE Main qualifiers)', month: 'May' },
    { name: 'BITSAT', description: 'BITS Pilani, Goa & Hyderabad entrance', month: 'May-Jun' },
    { name: 'MHT-CET', description: 'Maharashtra state engineering colleges', month: 'May' },
    { name: 'KCET', description: 'Karnataka state engineering colleges', month: 'Apr' },
    { name: 'VITEEE', description: 'VIT University entrance exam', month: 'Apr' },
    { name: 'SRMJEE', description: 'SRM University entrance exam', month: 'Apr' },
    { name: 'COMEDK', description: 'Karnataka private engineering colleges', month: 'May' },
  ],
  topColleges: [
    'IIT Bombay', 'IIT Delhi', 'IIT Madras', 'IIT Kanpur', 'IIT Kharagpur',
    'BITS Pilani', 'NIT Trichy', 'NIT Surathkal', 'VIT Vellore', 'IIIT Hyderabad',
    'Delhi Technological University', 'COEP Pune', 'PEC Chandigarh',
  ],
  duration: 'B.Tech: 4 years | B.E: 4 years | Diploma: 3 years',
  fees: '₹1L – ₹15L/year (Govt: ₹50K-2L/year)',
  scope: ['India: ₹3L – ₹60L/year', 'USA/Canada: $80K – $150K/year', 'Germany: €45K – €90K/year'],
};

export const medicalCareers = {
  id: 'medical',
  title: 'Medical & Healthcare',
  icon: '🏥',
  gradient: 'from-rose-500 to-pink-600',
  bgLight: 'bg-rose-50',
  textColor: 'text-rose-700',
  borderColor: 'border-rose-200',
  eligibility: 'After 12th (PCB) | Min 50-60% marks | NEET qualification required',
  overview: 'Medical and healthcare is a noble, evergreen field with immense job security. From treating patients to conducting research, opportunities are vast and growing with India\'s increasing healthcare needs.',
  branches: [
    {
      name: 'MBBS (Medicine & Surgery)',
      icon: '👨‍⚕️',
      jobs: ['General Physician', 'Specialist Doctor', 'Surgeon', 'Govt Hospital Doctor', 'Private Practitioner'],
      avgSalary: '₹8L – ₹50L+/year',
      demand: 'Very High',
    },
    {
      name: 'BDS (Dental Surgery)',
      icon: '🦷',
      jobs: ['Dentist', 'Orthodontist', 'Oral Surgeon', 'Dental Consultant'],
      avgSalary: '₹4L – ₹20L/year',
      demand: 'High',
    },
    {
      name: 'BAMS (Ayurveda)',
      icon: '🌿',
      jobs: ['Ayurvedic Doctor', 'Panchakarma Specialist', 'Ayurveda Researcher', 'Wellness Consultant'],
      avgSalary: '₹3L – ₹15L/year',
      demand: 'Growing',
    },
    {
      name: 'BHMS (Homeopathy)',
      icon: '💊',
      jobs: ['Homeopathic Doctor', 'Researcher', 'Wellness Practitioner', 'Govt Medical Officer'],
      avgSalary: '₹3L – ₹12L/year',
      demand: 'Moderate',
    },
    {
      name: 'B.Sc Nursing',
      icon: '💉',
      jobs: ['Staff Nurse', 'ICU Nurse', 'Nurse Educator', 'Healthcare Manager', 'International Nursing'],
      avgSalary: '₹2.5L – ₹15L/year (Abroad: ₹30L+)',
      demand: 'Very High',
    },
    {
      name: 'B.Sc Medical Lab Technology',
      icon: '🔬',
      jobs: ['Lab Technician', 'Pathologist Assistant', 'Research Associate', 'Diagnostic Specialist'],
      avgSalary: '₹2.5L – ₹10L/year',
      demand: 'High',
    },
    {
      name: 'B.V.Sc (Veterinary Science)',
      icon: '🐾',
      jobs: ['Veterinarian', 'Animal Researcher', 'Livestock Inspector', 'Zoo Vet'],
      avgSalary: '₹3L – ₹12L/year',
      demand: 'Moderate',
    },
    {
      name: 'B.Sc Agriculture',
      icon: '🌾',
      jobs: ['Agriculture Officer', 'Agronomist', 'Food Technologist', 'Farm Manager'],
      avgSalary: '₹2.5L – ₹12L/year',
      demand: 'High',
    },
  ],
  entranceExams: [
    { name: 'NEET-UG', description: 'Mandatory for MBBS, BDS, BAMS, BHMS, BUMS, B.V.Sc', month: 'May' },
    { name: 'AIIMS', description: 'Now through NEET (earlier separate exam)', month: 'May' },
    { name: 'JIPMER', description: 'Now through NEET', month: 'May' },
    { name: 'ICAR AIEEA', description: 'Agriculture universities (B.Sc Agri)', month: 'Jun' },
    { name: 'State Nursing CETs', description: 'State-level nursing college admission', month: 'May-Jun' },
  ],
  topColleges: [
    'AIIMS Delhi', 'AIIMS Mumbai', 'CMC Vellore', 'JIPMER Puducherry',
    'Maulana Azad Medical College', 'Grant Medical College Mumbai',
    'AFMC Pune', 'KMC Manipal', 'St. John\'s Medical College',
  ],
  duration: 'MBBS: 5.5 years | BDS: 5 years | BAMS/BHMS: 5.5 years | B.Sc Nursing: 4 years',
  fees: '₹30K – ₹15L/year (Govt: Free/Nominal | Private: up to ₹25L/year)',
  scope: ['India: ₹5L – ₹1Cr+/year (specialists)', 'UK/USA/Australia: $120K – $300K+/year', 'Middle East: ₹25L – ₹60L/year'],
};

export const pharmacyCareers = {
  id: 'pharmacy',
  title: 'Pharmacy',
  icon: '💊',
  gradient: 'from-emerald-500 to-teal-600',
  bgLight: 'bg-emerald-50',
  textColor: 'text-emerald-700',
  borderColor: 'border-emerald-200',
  eligibility: 'After 12th (PCM/PCB) | Min 45-50% marks',
  overview: 'Pharmacy is a rapidly growing field combining science, healthcare, and business. India is the world\'s largest generic medicine manufacturer, creating massive opportunities for pharmacy professionals.',
  branches: [
    {
      name: 'D.Pharma (Diploma)',
      icon: '📋',
      jobs: ['Pharmacist', 'Medical Store Owner', 'Hospital Pharmacist', 'Drug Inspector'],
      avgSalary: '₹2L – ₹8L/year',
      demand: 'High',
    },
    {
      name: 'B.Pharma (Bachelor)',
      icon: '🎓',
      jobs: ['Clinical Pharmacist', 'R&D Scientist', 'Quality Control Officer', 'Medical Representative', 'Drug Inspector'],
      avgSalary: '₹3L – ₹15L/year',
      demand: 'Very High',
    },
    {
      name: 'Pharm.D (Doctorate)',
      icon: '👩‍🔬',
      jobs: ['Clinical Pharmacist', 'Hospital Clinical Specialist', 'Pharmacovigilance Scientist'],
      avgSalary: '₹5L – ₹20L/year',
      demand: 'High',
    },
    {
      name: 'B.Pharma (Ayurveda)',
      icon: '🌿',
      jobs: ['Ayurvedic Medicine Specialist', 'Herbal Product Developer', 'Research Officer'],
      avgSalary: '₹2.5L – ₹10L/year',
      demand: 'Growing',
    },
    {
      name: 'Pharmaceutical Management',
      icon: '📊',
      jobs: ['Pharma Marketing Manager', 'Regulatory Affairs Officer', 'Supply Chain Manager'],
      avgSalary: '₹4L – ₹25L/year',
      demand: 'High',
    },
  ],
  entranceExams: [
    { name: 'GPAT', description: 'Graduate Pharmacy Aptitude Test for M.Pharma admission', month: 'Feb' },
    { name: 'MHT-CET Pharma', description: 'Maharashtra Pharmacy CET', month: 'May' },
    { name: 'UPSEE', description: 'UP State Pharmacy entrance', month: 'Apr' },
    { name: 'TS EAMCET', description: 'Telangana pharmacy admissions', month: 'May' },
    { name: 'PUCET', description: 'Panjab University CET for pharmacy', month: 'Jun' },
  ],
  topColleges: [
    'Jamia Hamdard Delhi', 'BITS Pilani (Pharma)', 'ICT Mumbai', 'JSS Pharmacy Mysore',
    'Manipal College of Pharmacy', 'Bombay College of Pharmacy', 'Amrita Pharmacy Coimbatore',
  ],
  duration: 'D.Pharma: 2 years | B.Pharma: 4 years | Pharm.D: 6 years',
  fees: '₹30K – ₹2L/year (Govt) | ₹1L – ₹5L/year (Private)',
  scope: ['India: ₹3L – ₹20L/year', 'USA/UK/Australia: $60K – $120K/year', 'Middle East: ₹15L – ₹35L/year'],
};

export const commerceCareers = {
  id: 'commerce',
  title: 'Commerce & Business',
  icon: '📈',
  gradient: 'from-blue-500 to-cyan-500',
  bgLight: 'bg-blue-50',
  textColor: 'text-blue-700',
  borderColor: 'border-blue-200',
  eligibility: 'After 12th (Commerce/Any Stream) | Various eligibility criteria',
  overview: 'Commerce offers diverse career paths in finance, accounting, business management, banking, and entrepreneurship. India\'s growing economy creates vast opportunities for commerce professionals.',
  branches: [
    {
      name: 'CA (Chartered Accountancy)',
      icon: '🏦',
      jobs: ['Chartered Accountant', 'CFO', 'Tax Consultant', 'Auditor', 'Financial Advisor'],
      avgSalary: '₹6L – ₹60L+/year',
      demand: 'Very High',
    },
    {
      name: 'CMA (Cost Management Accountant)',
      icon: '💰',
      jobs: ['Cost Accountant', 'Management Consultant', 'Finance Manager', 'Budget Analyst'],
      avgSalary: '₹4L – ₹25L/year',
      demand: 'High',
    },
    {
      name: 'CS (Company Secretary)',
      icon: '⚖️',
      jobs: ['Company Secretary', 'Legal Compliance Officer', 'Corporate Governance Expert'],
      avgSalary: '₹4L – ₹20L/year',
      demand: 'High',
    },
    {
      name: 'BBA / BMS',
      icon: '📋',
      jobs: ['Business Analyst', 'Marketing Manager', 'HR Manager', 'Operations Manager'],
      avgSalary: '₹3L – ₹20L/year (higher after MBA)',
      demand: 'Very High',
    },
    {
      name: 'B.Com / B.Com Honours',
      icon: '🎓',
      jobs: ['Accountant', 'Tax Officer', 'Bank PO', 'Finance Analyst', 'Govt Jobs'],
      avgSalary: '₹2.5L – ₹15L/year',
      demand: 'High',
    },
    {
      name: 'Economics (BA/B.Sc)',
      icon: '📉',
      jobs: ['Economist', 'Policy Analyst', 'Data Analyst', 'Banking', 'UPSC/Civil Services'],
      avgSalary: '₹3L – ₹20L/year',
      demand: 'Growing',
    },
    {
      name: 'Banking & Finance (BBA)',
      icon: '🏧',
      jobs: ['Bank PO/Clerk', 'Investment Banker', 'Relationship Manager', 'SEBI/RBI Officer'],
      avgSalary: '₹3L – ₹30L/year',
      demand: 'Very High',
    },
    {
      name: 'Digital Marketing & E-Commerce',
      icon: '🌐',
      jobs: ['Digital Marketer', 'SEO Specialist', 'E-Commerce Manager', 'Content Strategist'],
      avgSalary: '₹2.5L – ₹20L/year',
      demand: 'Extremely High',
    },
  ],
  entranceExams: [
    { name: 'CA Foundation', description: 'ICAI exam to start CA journey (after 12th)', month: 'May/Nov' },
    { name: 'CMA Foundation', description: 'ICMAI Cost Accountant entry exam', month: 'Jun/Dec' },
    { name: 'CS Foundation', description: 'ICSI Company Secretary entry exam', month: 'Jun/Dec' },
    { name: 'IPMAT', description: 'IIM Indore/Rohtak Integrated MBA (5-year)', month: 'May' },
    { name: 'DU JAT', description: 'Delhi University BBA/BMS entrance', month: 'Jun' },
    { name: 'SET', description: 'Symbiosis Entrance Test for BBA/BCA', month: 'May' },
    { name: 'NMIMS CET', description: 'NMIMS Mumbai BBA entrance', month: 'Mar' },
  ],
  topColleges: [
    'SRCC Delhi', 'Lady Shri Ram College', 'Shri Ram College of Commerce',
    'Christ University Bangalore', 'Narsee Monjee Mumbai', 'Symbiosis Pune',
    'NMIMS Mumbai', 'IIM Indore (IPM)', 'Loyola College Chennai',
  ],
  duration: 'B.Com: 3 years | BBA: 3 years | CA: 3-5 years | IPM MBA: 5 years',
  fees: '₹20K – ₹3L/year (Regular) | CA/CS/CMA: ₹10K – ₹50K total exam fees',
  scope: ['India: ₹3L – ₹60L+/year', 'USA/UK: $60K – $150K/year', 'Dubai/Singapore: ₹20L – ₹60L/year'],
};

export const artsCareers = {
  id: 'arts',
  title: 'Arts, Law & Humanities',
  icon: '🎨',
  gradient: 'from-pink-500 to-rose-500',
  bgLight: 'bg-pink-50',
  textColor: 'text-pink-700',
  borderColor: 'border-pink-200',
  eligibility: 'After 12th (Any Stream) | Various eligibility',
  overview: 'Arts and humanities offer diverse, fulfilling careers in law, civil services, journalism, design, teaching, and creative fields. These careers are gaining immense respect and remuneration.',
  branches: [
    {
      name: 'Law (LLB / BA LLB)',
      icon: '⚖️',
      jobs: ['Advocate', 'Corporate Lawyer', 'Judge', 'Legal Advisor', 'Civil Services (Legal)'],
      avgSalary: '₹3L – ₹50L+/year',
      demand: 'High',
    },
    {
      name: 'Journalism & Mass Communication',
      icon: '📰',
      jobs: ['Journalist', 'News Anchor', 'Content Creator', 'PR Manager', 'Media Consultant'],
      avgSalary: '₹2.5L – ₹20L/year',
      demand: 'High',
    },
    {
      name: 'Fashion Design',
      icon: '👗',
      jobs: ['Fashion Designer', 'Textile Designer', 'Stylist', 'Merchandiser', 'Brand Manager'],
      avgSalary: '₹2.5L – ₹25L/year',
      demand: 'Growing',
    },
    {
      name: 'Interior Design',
      icon: '🏠',
      jobs: ['Interior Designer', 'Space Planner', 'Set Designer', 'Exhibition Designer'],
      avgSalary: '₹3L – ₹20L/year',
      demand: 'Growing',
    },
    {
      name: 'Civil Services (UPSC/State PSC)',
      icon: '🏛️',
      jobs: ['IAS Officer', 'IPS Officer', 'IFS Officer', 'State Civil Services'],
      avgSalary: '₹8L – ₹25L+/year (+ benefits)',
      demand: 'Very High',
    },
    {
      name: 'Hotel Management',
      icon: '🏨',
      jobs: ['Hotel Manager', 'F&B Manager', 'Chef', 'Event Manager', 'Tourism Officer'],
      avgSalary: '₹3L – ₹20L/year (International: up to ₹50L)',
      demand: 'High',
    },
    {
      name: 'Animation & Multimedia',
      icon: '🎬',
      jobs: ['Animator', 'VFX Artist', 'Game Designer', 'Motion Graphics Artist', 'UI/UX Designer'],
      avgSalary: '₹3L – ₹25L/year',
      demand: 'Very High',
    },
    {
      name: 'Psychology / Social Work',
      icon: '🧠',
      jobs: ['Clinical Psychologist', 'Counsellor', 'HR Specialist', 'Social Worker', 'Researcher'],
      avgSalary: '₹2.5L – ₹15L/year',
      demand: 'Growing',
    },
  ],
  entranceExams: [
    { name: 'CLAT', description: 'Common Law Admission Test for NLUs (Law)', month: 'Dec' },
    { name: 'AILET', description: 'NLU Delhi Law entrance exam', month: 'Dec' },
    { name: 'UCEED', description: 'IIT Design programs entrance', month: 'Jan' },
    { name: 'NID DAT', description: 'National Institute of Design entrance', month: 'Jan' },
    { name: 'NIFT', description: 'National Institute of Fashion Technology', month: 'Jan' },
    { name: 'NCHMCT JEE', description: 'Hotel Management national entrance', month: 'Apr' },
    { name: 'IIMC Entrance', description: 'Indian Institute of Mass Communication', month: 'Apr' },
  ],
  topColleges: [
    'NLU Delhi (NLUD)', 'NLSIU Bangalore', 'NIFT Delhi/Mumbai', 'NID Ahmedabad',
    'IHM Mumbai', 'Lady Shri Ram (Journalism)', 'IIMC Delhi', 'Tata Institute of Social Sciences',
    'Sophia College Mumbai', 'Miranda House Delhi',
  ],
  duration: 'BA/BFA: 3 years | Law (BA LLB): 5 years | Hotel Management: 3-4 years',
  fees: '₹20K – ₹3L/year (Govt) | ₹1L – ₹8L/year (Private)',
  scope: ['India: ₹2.5L – ₹50L+/year (varies by field)', 'International opportunities widely available'],
};

export const designCareers = {
  id: 'design',
  title: 'Design & Animation',
  icon: '🎨',
  gradient: 'from-pink-500 to-fuchsia-600',
  bgLight: 'bg-pink-50',
  textColor: 'text-pink-700',
  borderColor: 'border-pink-200',
  eligibility: 'After 12th (Any Stream) | Portfolio + entrance exam based',
  overview: 'Design and animation combine creativity, technology, and storytelling. It opens careers in fashion, product design, UI/UX, motion graphics, animation, VFX, and game design.',
  branches: [
    {
      name: 'Fashion & Textile Design',
      icon: '👗',
      jobs: ['Fashion Designer', 'Textile Designer', 'Stylist', 'Brand Designer'],
      avgSalary: '₹2.5L – ₹25L/year',
      demand: 'Growing',
    },
    {
      name: 'Product & Industrial Design',
      icon: '🧩',
      jobs: ['Product Designer', 'Industrial Designer', 'Prototype Designer', 'Design Strategist'],
      avgSalary: '₹4L – ₹30L/year',
      demand: 'High',
    },
    {
      name: 'UI/UX Design',
      icon: '📱',
      jobs: ['UI Designer', 'UX Researcher', 'Product Designer', 'Interaction Designer'],
      avgSalary: '₹4L – ₹35L/year',
      demand: 'Very High',
    },
    {
      name: 'Animation, VFX & Motion Graphics',
      icon: '🎬',
      jobs: ['Animator', 'VFX Artist', 'Motion Designer', '3D Artist', 'Storyboard Artist'],
      avgSalary: '₹3L – ₹30L/year',
      demand: 'Very High',
    },
    {
      name: 'Interior & Space Design',
      icon: '🏠',
      jobs: ['Interior Designer', 'Space Planner', 'Exhibition Designer', 'Set Designer'],
      avgSalary: '₹3L – ₹20L/year',
      demand: 'Growing',
    },
    {
      name: 'Game Design & Creative Tech',
      icon: '🕹️',
      jobs: ['Game Designer', 'Level Designer', 'Creative Technologist', '3D Environment Artist'],
      avgSalary: '₹4L – ₹28L/year',
      demand: 'High',
    },
  ],
  entranceExams: [
    { name: 'NIFT', description: 'Fashion and design entrance for top fashion institutes', month: 'Jan' },
    { name: 'NID DAT', description: 'National Institute of Design entrance', month: 'Jan' },
    { name: 'UCEED', description: 'IIT design programs entrance', month: 'Jan' },
    { name: 'CEED', description: 'Postgraduate design entrance', month: 'Jan' },
    { name: 'Pearl Academy Entrance', description: 'Private design institute admission', month: 'Jan/Apr' },
  ],
  topColleges: [
    'NID Ahmedabad', 'NIFT Delhi', 'NIFT Mumbai', 'IIT Bombay (IDC)',
    'Pearl Academy Delhi', 'Srishti Manipal', 'MIT Institute of Design', 'UID Ahmedabad',
  ],
  duration: 'B.Des: 4 years | M.Des: 2 years | Animation diplomas: 1-3 years',
  fees: '₹50K – ₹4L/year (Govt) | ₹2L – ₹8L/year (Private)',
  scope: ['India: ₹3L – ₹30L+/year', 'Freelance / studio / startup opportunities', 'International: $40K – $120K/year'],
};

export const latestExams2026 = [
  {
    name: 'JEE Main 2026',
    stream: 'Engineering',
    date: 'Session 1: Jan 2026 | Session 2: Apr 2026',
    eligibility: '12th PCM | Min 75%',
    level: 'National',
    color: 'bg-violet-100 text-violet-800',
    dot: 'bg-violet-500',
    status: 'Completed',
  },
  {
    name: 'NEET-UG 2026',
    stream: 'Medical',
    date: 'May 2026',
    eligibility: '12th PCB | Min 50%',
    level: 'National',
    color: 'bg-rose-100 text-rose-800',
    dot: 'bg-rose-500',
    status: 'Upcoming',
  },
  {
    name: 'CLAT 2026',
    stream: 'Law',
    date: 'December 7, 2025',
    eligibility: '12th Any Stream | Min 45%',
    level: 'National',
    color: 'bg-amber-100 text-amber-800',
    dot: 'bg-amber-500',
    status: 'Completed',
  },
  {
    name: 'CA Foundation 2026',
    stream: 'Commerce',
    date: 'May 2026',
    eligibility: '12th Any Stream',
    level: 'National',
    color: 'bg-blue-100 text-blue-800',
    dot: 'bg-blue-500',
    status: 'Upcoming',
  },
  {
    name: 'BITSAT 2026',
    stream: 'Engineering',
    date: 'Session 1: Apr 15-17 | Session 2: May 24-26',
    eligibility: '12th PCM | Min 75%',
    level: 'University',
    color: 'bg-indigo-100 text-indigo-800',
    dot: 'bg-indigo-500',
    status: 'Upcoming',
  },
  {
    name: 'GPAT 2026',
    stream: 'Pharmacy',
    date: 'March 2026',
    eligibility: 'B.Pharma graduates',
    level: 'National',
    color: 'bg-emerald-100 text-emerald-800',
    dot: 'bg-emerald-500',
    status: 'Completed',
  },
  {
    name: 'MHT-CET 2026',
    stream: 'Engineering/Pharmacy',
    date: 'April-May 2026',
    eligibility: '12th PCM/PCB | Min 45-50%',
    level: 'State',
    color: 'bg-orange-100 text-orange-800',
    dot: 'bg-orange-500',
    status: 'Upcoming',
  },
  {
    name: 'IPMAT 2026',
    stream: 'Commerce/MBA',
    date: 'May 4, 2026',
    eligibility: '12th Any Stream | Min 60%',
    level: 'National',
    color: 'bg-cyan-100 text-cyan-800',
    dot: 'bg-cyan-500',
    status: 'Upcoming',
  },
  {
    name: 'NIFT 2026',
    stream: 'Design',
    date: 'Stage 1 complete | Stage 2 ongoing',
    eligibility: '12th Any Stream',
    level: 'National',
    color: 'bg-pink-100 text-pink-800',
    dot: 'bg-pink-500',
    status: 'Active',
  },
  {
    name: 'NCHMCT JEE 2026',
    stream: 'Hotel Management',
    date: 'April 2026',
    eligibility: '12th Any Stream | Min 45%',
    level: 'National',
    color: 'bg-lime-100 text-lime-800',
    dot: 'bg-lime-500',
    status: 'Upcoming',
  },
  {
    name: 'JEE Advanced 2026',
    stream: 'Engineering (IITs)',
    date: 'May 2026',
    eligibility: 'JEE Main Top 2.5 Lakh',
    level: 'National',
    color: 'bg-purple-100 text-purple-800',
    dot: 'bg-purple-500',
    status: 'Upcoming',
  },
  {
    name: 'VITEEE 2026',
    stream: 'Engineering',
    date: 'Apr 28 - May 3, 2026',
    eligibility: '12th PCM | Min 60%',
    level: 'University',
    color: 'bg-teal-100 text-teal-800',
    dot: 'bg-teal-500',
    status: 'Upcoming',
  },
];

export const stats = [
  { label: 'Career Paths', value: '500+', icon: '🎯' },
  { label: 'Top Colleges', value: '1000+', icon: '🏛️' },
  { label: 'Entrance Exams', value: '50+', icon: '📝' },
  { label: 'Job Opportunities', value: '10M+', icon: '💼' },
];
